import React from "react";
import { NavLink } from "react-router-dom";
import { Calendar, Users, Settings, Gauge, CreditCard } from "lucide-react";
import { useProfissionalRotulo } from "../contexts/ProfissionalRotuloContext";

const Sidebar = () => {
  const { labels, carregando } = useProfissionalRotulo();
  const rotuloMenu = carregando
    ? "\u00A0"
    : labels?.plural || "Profissionais";

  return (
    <aside className="sidebar">
      <div className="sidebar__brand">Fila Zero Admin</div>

      <nav className="nav">
        <NavLink to="/dashboard" className={({isActive}) => isActive ? "active" : undefined} onClick={() => document.body.classList.remove('sidebar-open')}>
          <Gauge /> <span>Dashboard</span>
        </NavLink>
        <NavLink to="/agendamentos" className={({isActive}) => isActive ? "active" : undefined} onClick={() => document.body.classList.remove('sidebar-open')}>
          <Calendar /> <span>Agendamentos</span>
        </NavLink>
        <NavLink to="/profissionais" className={({isActive}) => isActive ? "active" : undefined} onClick={() => document.body.classList.remove('sidebar-open')}>
          <Users /> <span style={{ minWidth: 72, display: "inline-block" }}>{rotuloMenu}</span>
        </NavLink>
        <NavLink to="/servicos" className={({isActive}) => isActive ? "active" : undefined} onClick={() => document.body.classList.remove('sidebar-open')}>
          <Settings /> <span>Serviços</span>
        </NavLink>
        <NavLink to="/estabelecimentos" className={({isActive}) => isActive ? "active" : undefined} onClick={() => document.body.classList.remove('sidebar-open')}>
          <Users /> <span>Estabelecimentos</span>
        </NavLink>
      </nav>

      <nav className="nav nav--footer">
        <NavLink to="/configuracoes" className={({isActive}) => isActive ? "active" : undefined} onClick={() => document.body.classList.remove('sidebar-open')}>
          <Settings /> <span>Configurações</span>
        </NavLink>
        <NavLink to="/assinatura" className={({isActive}) => isActive ? "active" : undefined} onClick={() => document.body.classList.remove('sidebar-open')}>
          <CreditCard /> <span>Plano e assinatura</span>
        </NavLink>
      </nav>
    </aside>
  );
};

export default Sidebar;
